var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTestDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65082 5.79396C8.5757 5.41086 9.55588 5.1826 10.5521 5.11697C10.9073 5.09357 11.2199 5.3344 11.3153 5.67728C11.4559 6.18244 11.0745 6.6822 10.5547 6.75114C9.8732 6.84153 9.2049 7.02055 8.56703 7.28476C7.60703 7.68241 6.73475 8.26525 6 9C5.26525 9.73475 4.68241 10.607 4.28476 11.567C4.01892 12.2088 3.83933 12.8814 3.74948 13.5673C3.68034 14.0951 3.19424 14.4952 2.6727 14.3886C2.28116 14.3085 1.99579 13.9635 2.02574 13.565C2.09843 12.5978 2.3245 11.6468 2.69679 10.748C3.15682 9.63739 3.83109 8.62828 4.6811 7.77827C5.53111 6.92826 6.54022 6.25399 7.65082 5.79396Z",
    fill: "#008686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3032 10.748C17.9472 9.8885 17.4628 9.08975 16.868 8.37849C16.5765 8.02997 16.0553 8.02252 15.722 8.33126C15.3701 8.65717 15.3635 9.20786 15.6629 9.58247C16.1267 10.1626 16.5074 10.8063 16.7928 11.4952C17.0607 12.1421 17.2059 12.853 17.272 13.5658C17.3212 14.0959 17.8057 14.4952 18.3273 14.3886C18.7188 14.3086 19.0042 13.9636 18.9743 13.5651C18.9016 12.5979 18.6755 11.6468 18.3032 10.748Z",
    fill: "#008686"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3049 5.45139C14.344 5.39479 14.4203 5.37838 14.4792 5.41393C14.5374 5.44903 14.5588 5.52294 14.5283 5.58365L10.8251 12.9742C10.6398 13.344 10.1786 13.4774 9.82452 13.2636C9.47457 13.0524 9.37518 12.5898 9.60747 12.2534L14.3049 5.45139Z",
    fill: "#008686",
    stroke: "#008686",
    strokeWidth: 1.30769
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDrive);
export default ForwardRef;